import styles from '../../styles/inlineOptions.module.css'
import React, { useMemo } from 'react'
import { Box, Menu, MenuButton, MenuItem, MenuList, Flex } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import useLocaleText from 'components/useLocaleText'

import { Controller, useFormContext } from 'react-hook-form'
import { WidgetWrapper } from 'components/TasksV2/UI/WidgetWrapper'
import { FormInputLabel } from 'components/TasksV2/UI/FormInputLabel'
import { ChevronDown } from 'lucide-react'
import { PRIORITY_OPTIONS } from '../../utils'

const Bullet = ({ bgColor }: { bgColor: string }) => {
  return <Box borderRadius="10px" bg={bgColor} p="5px" w="20px" h="20px" />
}

export const PrioritySelection = ({ inline = false }: { inline?: boolean }) => {
  const { control, watch } = useFormContext()

  const t_pick_priority = useLocaleText('pick_priority')

  const priority = watch('priority')

  const foundPriority = useMemo(
    () =>
      PRIORITY_OPTIONS.find((priorityOption) => {
        const priorityValue = priorityOption.value

        return priorityValue === priority
      }),
    [priority]
  )

  return (
    <Controller
      name="priority"
      control={control}
      as={
        inline ? (
          <div className={styles.options}>
            {PRIORITY_OPTIONS.map((option) => (
              <button
                type="button"
                key={option.value}
                className={priority === option.value ? styles.selected : ''}
                aria-pressed={priority === option.value}
                onClick={() => control.setValue('priority', option.value)}
              >
                <span style={{ background: option.bgColor }} className={styles.priorityDot} />
                <LocaleText text={option.label} />
              </button>
            ))}
          </div>
        ) : (
          <Box w="100%">
            <FormInputLabel label={t_pick_priority} />
            <Flex alignItems="center" style={{ columnGap: '10px' }} w="max-content" flexDir="row-reverse">
              <Menu>
                <MenuButton as={Flex} w="100%" style={{ columnGap: '10px' }} alignItems="center">
                  <WidgetWrapper
                    p="10px"
                    cursor="pointer"
                    isError={false}
                    w="100%"
                    justifyContent="space-between"
                    flexDir="row"
                    alignItems="center"
                  >
                    <Flex
                      alignItems="center"
                      minW="200px"
                      flexDir="row"
                      justifyContent="flex-start"
                      style={{ columnGap: '10px' }}
                    >
                      {foundPriority && <Bullet bgColor={foundPriority.bgColor} />}
                      <LocaleText text={foundPriority?.label || t_pick_priority} />
                    </Flex>
                    <ChevronDown />
                  </WidgetWrapper>
                </MenuButton>
                <MenuList
                  overflowY="auto"
                  fontSize="14px"
                  fontWeight="500"
                  borderRadius="10px"
                  placement="bottom-start"
                  py={0}
                >
                  {PRIORITY_OPTIONS.map((priorityOption) => (
                    <MenuItem
                      key={priorityOption.value}
                      onClick={() => control.setValue('priority', priorityOption.value)}
                      py="10px"
                      style={{ columnGap: '10px' }}
                    >
                      <Bullet bgColor={priorityOption.bgColor} />
                      <LocaleText text={priorityOption.label || t_pick_priority} />
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Flex>
          </Box>
        )
      }
    />
  )
}

export default PrioritySelection
